import { render, staticRenderFns } from "./OrganismIdcCreateEditContactPointOrSale.vue?vue&type=template&id=84fe0bc2&scoped=true&"
import script from "./OrganismIdcCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"
export * from "./OrganismIdcCreateEditContactPointOrSale.vue?vue&type=script&lang=js&"
import style0 from "./OrganismIdcCreateEditContactPointOrSale.vue?vue&type=style&index=0&id=84fe0bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe0bc2",
  null
  
)

export default component.exports